export enum ETextFieldType {
  TEXT = 'text',
  SIGNATURE = 'signature',
}

export enum EPageVisibility {
  PRIVATE = 'private',
  PUBLIC = 'public',
  PASSWORD_PROTECTED = 'password_protected',
}

export enum EPageDynamicElementType {
  PAGE_DEPARTMENT_SECTION = 'page_department_section',
  BANNER = 'banner',
  CARD_GALLERY = 'card_gallery',
  CATEGORY_GALLERY = 'category_gallery',
  VIDEO_GALLERY = 'video_gallery',
  QUICK_CATEGORIES_SECTION = 'quick_categories_section',
}

export enum EPageMenuType {
  TOP_MENU_1 = 'top_menu_1',
  TOP_MENU_2 = 'top_menu_2',
  FOOTER_MENU = 'footer_menu',
}

export enum EPageSubmenuType {
  ALL_SIMCHAS = 'all_simchas',
  ALL_SEASONS = 'all_seasons',
  DEFAULT = 'default',
  SIMCHAS = 'simchas',
  OCCASIONS = 'occasions',
}

export enum ECardTextVersion {
  V_1 = 'v1',
  V_2 = 'v2',
  V_3 = 'v3',
}

export enum ECardInsertedImageVersion {
  V_1 = 'v1',
  V_2 = 'v2',
}

export enum ECardSecondaryImageVersion {
  V_1 = 'v1',
  V_2 = 'v2',
}

export enum ECardLogoVersion {
  V_1 = 'v1',
  V_2 = 'v2',
}
